import React from 'react';
import {
  RefreshButtonTextProps,
  reloadButton,
} from '@components/sources/visualizer/mappingScreens/config/mappingConfig/SelectUniqueIdentifier';
import RefreshButton from '@components/sources/visualizer/mappingScreens/config/mappingConfig/refreshButton';
import useStores from '@stores/useStores';
import {
  fetchErrorAssets,
  ErrorProps,
} from '@components/sources/visualizer/mappingScreens/errorsView';
import { ISourceInfo } from './tableMappingProvider';
import {
  getApiErrorMessageDetails,
  getRespData,
} from '@components/sources/visualizer/mappingScreens/sourceUtil';

interface ReloadPreviewProps {
  refreshPreview: (rows: Record<string, unknown>[]) => void;
  hide: boolean;
  sourceConfig?: ISourceInfo;
  role: string;
  updateSchemaErrors: (errorItems: ErrorProps[]) => void;
}

const ReloadPreview: React.FC<ReloadPreviewProps> = ({
  refreshPreview,
  hide,
  sourceConfig,
  role,
  updateSchemaErrors,
}: ReloadPreviewProps) => {
  const { messagesStore, sourceDataStore } = useStores();

  const fetchPreview = async () => {
    updateSchemaErrors([fetchErrorAssets('preview')]);
    const respDataObj = await sourceDataStore.getPreview(
      sourceConfig?.accountId || '',
      role,
      sourceConfig || {},
    );
    const { rows } = getRespData(respDataObj);

    return rows;
  };
  const refreshPreviewButton = (buttonProperties: RefreshButtonTextProps) =>
    reloadButton(buttonProperties, 'preview');
  return (
    <RefreshButton
      hide={hide}
      onComplete={refreshPreview}
      fetchDataOnClick={fetchPreview}
      ButtonComp={refreshPreviewButton}
      onIncomplete={(err) => {
        const errMsg = getApiErrorMessageDetails(err, 'Could not fetch preview');
        updateSchemaErrors([fetchErrorAssets('preview', errMsg.message)]);
        messagesStore.showErrorMessage(errMsg.messageWithFallback);
      }}
    />
  );
};
export default ReloadPreview;
